<template>
    <div class="strategyLayout1" ref="strategyLayout">
        <div class="titleStrate">
            <p>智慧醫療中心合縱連橫策略佈局</p>
            <p>WHAT WE COVER</p>
        </div>
        <div class="conStrate">
            <div class="conSLeft">
                <p>
                    疆域醫創作為鴻海科技集團全資子公司，依託鴻海在臺灣數位健康大聯盟的核心領導地位，專注智慧醫療設備研發、智慧醫療平臺搭建、遠距醫療服務三大面向，在產、學、研、醫、慈善、宗教民俗等多個領域擁有廣泛的合作夥伴和資源優勢，竭力成為全球領先的智慧醫療服務提供者。
                </p>
                <div class="conSLeftB">
                    <div v-for="(item, index) in layoutList" :key="index" class="fade-in">
                        <div class="fade-in-title">
                            <div class="fade-in-count">{{ animatedCounts[index] }}</div>
                            <div class="fade-in-units">{{ item.units }}</div>
                        </div>
                        <div class="fade-content">{{ item.content }}</div>
                    </div>
                </div>
            </div>
            <div class="conSRight">
                <div class="mapClass">
                    <img @mouseenter="handleGpsEnterFun(1)" @mouseleave="handleGpsLeave(1)"
                        :src="isMouseEnter1 ? Gps : unGps" alt="" />
                    <img @mouseenter="handleGpsEnterFun(2)" @mouseleave="handleGpsLeave(2)"
                        :src="isMouseEnter2 ? Gps : unGps" alt="" />
                    <img @mouseenter="handleGpsEnterFun(4)" @mouseleave="handleGpsLeave(4)"
                        :src="isMouseEnter3 ? Gps : unGps" alt="" />
                    <img @mouseenter="handleGpsEnterFun(3)" @mouseleave="handleGpsLeave(3)"
                        :src="isMouseEnter4 ? Gps : unGps" alt="" />
                    <div :class="isMouseEnter1 ? 'tips1' : isMouseEnter2 ? 'tips2' : isMouseEnter3 ? 'tips3' : 'tips4'"
                        v-if="isMouseEnter1 || isMouseEnter2 || isMouseEnter3 || isMouseEnter4">
                        <div v-for="(item, index) in enterDialogShow" :key="index">
                            <p class="tipsTitle">{{ item.title }}</p>
                            <div class="tipsContent" v-for="(i, index) in item.list" :key="index">
                                <p class="tipsConTitle">{{ i.title }}</p>
                                <div class="tipsConCon" v-for="(j, index) in i.content" :key="index">
                                    <p style="position: relative;top: -2px;">.</p>
                                    <p style="margin-left:4px;letter-spacing: 0.5px;line-height: 19.6px;" v-html="j"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import bgp from "@/assets/icon/image.png";
import G1 from "@/assets/img/map/x3/36/pindefault_web.png";
import G2 from "@/assets/img/map/x3/36/pinactive_web.png";
export default {
    name: "strategyLayout",
    data() {
        return {
            bgp: bgp,
            layoutList: [
                {
                    count: 7,
                    units: "+ 個",
                    content: "分佈城市",
                },
                {
                    count: 25,
                    units: "+ 家",
                    content: "合作夥伴",
                },
                {
                    count: 20,
                    units: "+ 位",
                    content: "AI技術專家",
                },
                {
                    count: 30,
                    units: "+ 位",
                    content: "資深開發人員",
                },
                {
                    count: 183,
                    units: "+ 項",
                    content: "申請專利總數",
                },
            ],
            animatedCounts: [],
            unGps: G1,
            Gps: G2,
            isMouseEnter1: false,
            isMouseEnter2: false,
            isMouseEnter3: false,
            isMouseEnter4: false,
            enterDialog: [
                {
                    title: "北部",
                    list: [
                        {
                            title: '新北市立土城醫院',
                            content: ["心電圖應用軟體分類演算法臨床效能評估研究", "智護心脈：AI 雲端預警，守護腦心同行", "運用穿戴式裝置測量 HRV 建立自律神經檢測 AI 模型"]
                        },
                        {
                            title: "林口長庚醫院眼科部",
                            content: ["CoDoctor Eye 手持式智慧眼底影像擷取儀", "CoDoctor AI 眼底影像人工輔助診斷模型"],
                        },
                        {
                            title: "天主教耕莘醫院",
                            content: ["「在宅急症照護 (Hospital at Home, HaH)」計畫-攜手實現在地安老"],
                        },
                    ],
                },
                {
                    title: "中部",
                    list: [
                        {
                            title: "台中榮⺠總醫院",
                            content: [
                                "護理協作機器人",
                                "精準醫療數位孿生<br>1. 乳癌用藥預測<br>2. 冠心病模擬疾病預測",
                            ],
                        },
                        {
                            title: "童綜合醫院",
                            content: [
                                "智慧照護重「心」出發 – 達文⻄心臟術後遠端ECG 實時監控系統",
                                "攝護腺影像 AI 區域偵測輔助診斷模型",
                                "白沙屯智慧醫院"
                            ],
                        },
                        {
                            title: "智慧生活 幸福萬家 - 雙橡園智慧社區",
                            content: [],
                        },
                    ],
                },
                {
                    title: "南部",
                    list: [
                        {
                            title: "高雄醫學大學附設中和紀念醫院",
                            content: [
                                "高齡照護者的科技賦能"
                            ],
                        },
                        {
                            title: "高雄市立鳳山醫院",
                            content: [
                                "亞灣 2.0 智慧城市 - 數位健康賦能城市健康管理醫事 C 巷弄長照站"
                            ],
                        },
                    ],
                },
                {
                    title: "東部",
                    list: [
                        {
                            title: "慈濟基金會 - 人醫會、慈發處",
                            content: [
                                "原鄉健康齊關心 數位科技傳溫情",
                                "偏鄉社區缺醫療 數位科技護孤老",
                                "大愛道場社區情 數位健康來關心",
                            ],
                        },
                        {
                            title: "已投入：",
                            content: [
                                "新竹縣尖石鄉、五峰鄉、關⻄鄉、峨嵋鄉、北埔鄉、寶山鄉及橫山鄉等七個衛生所",
                                "嘉義縣阿里山鄉、大埔鄉、竹崎鄉、梅山鄉、番路鄉、義竹鄉、布袋鎮、溪口鄉、中埔鄉、六腳鄉、東石鄉、鹿草鄉等鄉鎮衛生所",
                            ],
                        },
                    ],
                },
            ],
            enterDialogShow: [],
            intervalId: null,
            count: 1, // 初始化为1
        };
    },
    watch: {
        isMouseEnter1(newval, old) {
            console.log('isMouseEnter1', newval, old);
        },
        isMouseEnter2(val, oval) {
            console.log('isMouseEnter2', val, oval);
        },
        isMouseEnter3(value1, value2) {
            console.log('isMouseEnter3', value1, value2);
        },
        isMouseEnter4(val1, val2) {
            console.log('isMouseEnter4', val1, val2);
        }
    },
    mounted() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.setCount(); // 调用组件内部的函数
                    this.handleGpsEnter(1)
                    this.intervalId = setInterval(() => {
                        this.count = (this.count % 4) + 1; // 更新数字，循环在1、2、3之间
                        this.handleGpsEnter(this.count); // 传入当前的数字
                    }, 5000); // 5秒执行一次
                } else {
                    clearInterval(this.intervalId);
                    this.count = 1
                    this.isMouseEnter1 = false
                    this.isMouseEnter2 = false
                    this.isMouseEnter3 = false
                    this.isMouseEnter4 = false
                }
            });
        });

        observer.observe(this.$refs.strategyLayout);
    },
    methods: {
        // 處理數字
        setCount() {
            const duration = 1000; // 1秒
            const interval = 50; // 每次增加的间隔时间
            const totalCount = this.layoutList.map(item => item.count);
            const steps = totalCount.map(count => Math.ceil(count * (interval / duration)));

            let currentCounts = Array.from({ length: totalCount.length }, () => 0);
            const startTime = Date.now();

            const updateCounts = () => {
                const currentTime = Date.now();
                const elapsedTime = currentTime - startTime;

                if (elapsedTime < duration) {
                    currentCounts = totalCount.map((count, index) => Math.min(Math.ceil((elapsedTime / duration) * count), count));
                    this.animatedCounts = currentCounts;
                    setTimeout(updateCounts, interval);
                } else {
                    this.animatedCounts = totalCount;
                }
            };

            updateCounts();
        },

        handleGpsEnter(type) {
            if (type === 1) {
                this.isMouseEnter1 = true;
                this.isMouseEnter2 = false
                this.isMouseEnter3 = false
                this.isMouseEnter4 = false
                let arr1 = this.enterDialog;
                if (arr1.length > 0) {
                    this.enterDialogShow = arr1.slice(0, 1);
                }
            } else if (type === 2) {
                this.isMouseEnter2 = true;
                this.isMouseEnter1 = false
                this.isMouseEnter3 = false
                this.isMouseEnter4 = false
                let arr2 = this.enterDialog;
                if (arr2.length > 1) {
                    this.enterDialogShow = arr2.slice(1, 2);
                }
            } else if (type === 4) {
                this.isMouseEnter3 = true;
                this.isMouseEnter1 = false
                this.isMouseEnter2 = false
                this.isMouseEnter4 = false
                let arr3 = this.enterDialog;
                if (arr3.length > 0) {
                    this.enterDialogShow = arr3.slice(arr3.length - 1);
                }
            } else {
                this.isMouseEnter4 = true
                this.isMouseEnter1 = false
                this.isMouseEnter2 = false
                this.isMouseEnter3 = false
                let arr4 = this.enterDialog;
                if (arr4.length > 1) {
                    this.enterDialogShow = arr4.slice(2, 3);
                }
            }
        },
        handleGpsLeave(type) {
            if (type === 1) {
                this.isMouseEnter1 = false;
            } else if (type === 2) {
                this.isMouseEnter2 = false;
            } else if (type === 4) {
                this.isMouseEnter3 = false;
            } else {
                this.isMouseEnter4 = false;
            }
            this.handleGpsEnter(this.count); // 传入当前的数字
            this.intervalId = setInterval(() => {
                this.count = (this.count % 4) + 1; // 更新数字，循环在1、2、3之间
                this.handleGpsEnter(this.count); // 传入当前的数字
            }, 5000); // 5秒执行一次
        },
        handleGpsEnterFun(type) {
            console.log(this.count, '清除定时器前');
            clearInterval(this.intervalId);
            this.handleGpsEnter(type)
        }
    },
};
</script>

<style lang="less">
.strategyLayout1 {
    width: 80%;
    margin: 0px auto;
    padding-top: 100px;
    height: 800px;

    .titleStrate {
        text-align: left;

        p:first-child {
            height: 32px;
            font-size: 32px;
            font-weight: 500;
            line-height: 32px;
            color: #333333;
            font-family: "Noto Sans CJK TC";
        }

        p:nth-child(2) {
            font-family: 'Syncopate';
            font-size: 24px;
            line-height: 24px;
            height: 24px;
            font-weight: 400;
            color: #0052a4;
            margin-top: 16px;
            opacity: 0.8;
        }
    }

    .conStrate {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        .conSLeft {
            width: 456px;
            margin-top: 25px;

            p:first-child {
                font-weight: 400;
                font-size: 16px;
                line-height: 25.6px;
                text-align: justify;
                text-indent: 2em;
                color: #333333;
                font-family: "Noto Sans CJK TC";
            }

            .conSLeftB {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                margin: 80px auto;

                .fade-in {
                    width: 120px;
                    margin: 25px 16px 16px 0px;

                    .fade-in-title {
                        width: 120px;
                        display: flex;
                        color: #0052a4;
                        font-size: 16px;
                        font-weight: 400;
                        justify-content: space-evenly;
                        align-items: flex-end;

                        .fade-in-count {
                            font-size: 60px;
                            font-weight: 700;
                            line-height: 60px;
                            text-align: center;
                            font-style: italic;
                            font-family: 'HarmonyOS Sans';
                        }

                        .fade-in-units {
                            font-family: "Noto Sans CJK TC";
                        }
                    }

                    .fade-content {
                        font-family: "Noto Sans CJK TC";
                        font-weight: 500;
                        font-size: 18px;
                        line-height: 18px;
                        text-align: center;
                        margin-top: 12px;
                        width: 120px;
                    }
                }

                .fade-in:nth-child(5) {
                    width: 148px !important;

                    .fade-in-title {
                        width: 148px !important;
                    }
                }
            }
        }

        .conSRight {
            width: 55%;
            height: 620px;
            position: relative;

            .mapClass {
                background-image: url("@/assets/img/map/x3/456/map_web.png");
                background-repeat: no-repeat;
                background-size: 456px 616px;
                width: 100%;
                height: 100%;
                position: relative;
                top: -50px;
                left: 120px;

                img {
                    width: 36px;
                    height: 36px;
                }

                img:first-child {
                    position: absolute;
                    left: 359px;
                    top: 40px;
                }

                img:nth-child(2) {
                    position: absolute;
                    left: 225px;
                    top: 175px;
                }

                img:nth-child(3) {
                    position: absolute;
                    left: 335px;
                    top: 270px;
                }

                img:nth-child(4) {
                    position: absolute;
                    left: 203px;
                    top: 390px;
                }

                .tips1,
                .tips2,
                .tips3,
                .tips4 {
                    background: rgba(13, 38, 63, 0.8);
                    text-align: left;
                    padding: 24px 28px;
                    border-radius: 20px;
                    color: #ffffff;
                    z-index: 99;

                    .tipsTitle {
                        font-size: 20px;
                        line-height: 20px;
                        font-weight: 500;
                        padding-bottom: 10px;
                        border-bottom: 2px solid #ffffff;
                    }

                    .tipsContent {
                        margin: 20px 0 0 0;

                        .tipsConTitle {
                            font-size: 16px;
                            line-height: 16px;
                            font-weight: 500;
                            margin-bottom: 10px;
                        }

                        .tipsConCon {
                            font-weight: 400;
                            font-size: 16px;
                            display: flex;
                            margin: 5px 0;
                            font-family: "Noto Sans CJK TC";
                        }
                    }
                }

                .tips1 {
                    width: 380px;
                    position: absolute;
                    top: 81px;
                    left: -58px;
                }

                .tips2 {
                    width: 336px;
                    position: absolute;
                    top: 215px;
                    left: -89px;
                }

                .tips3 {
                    position: absolute;
                    top: 312px;
                    left: -22px;
                    width: 400px;
                }

                .tips4 {
                    position: absolute;
                    top: 144px;
                    left: 91px;
                    width: 347px;
                }
            }
        }
    }
}

@media only screen and (min-width: 1919px) {
    .strategyLayout1 {
        width: 1440px;

        .titleStrate {
            width: 1152px;
            margin: 0 auto;
        }

        .conStrate {
            width: 1152px;
            margin: 0 auto;

            .conSLeft {
                .conSLeftB {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    /* 允许换行 */
                    margin: 80px auto;
                    position: relative;
                }

                .conSLeftB>div:nth-child(2) {
                    width: calc(100% - 160px);
                    position: relative;
                    left: 25px;
                }
            }
        }
    }
}

@media only screen and (min-width: 1439px) and (max-width: 1919px) {
    .strategyLayout1 {
        .conStrate {
            .conSLeft {
                .conSLeftB {
                    position: relative;
                }

                .conSLeftB>div:nth-child(2) {
                    width: calc(100% - 160px);
                    position: relative;
                    left: 25px;
                }
            }
        }
    }
}

@media only screen and (min-width: 1023px) and (max-width: 1439px) {
    .strategyLayout1 {
        .conStrate {
            .conSLeft {
                p:first-child {
                    width: 800px;
                }

                .conSLeftB {
                    margin: 50px 0;
                    width: 288px;

                    .fade-in {
                        margin: 40px -20px 16px 0;
                        ;
                    }
                }
            }

            .conSRight {
                .mapClass {
                    background-image: url('@/assets/img/map/x3/320/map_pad&phone.png') !important;
                    background-repeat: no-repeat !important;
                    background-size: 320px 432px !important;
                    width: 100%;
                    height: 100%;
                    position: relative;
                    top: 145px;
                    left: 60px;

                    img {
                        width: 25.26px;
                        height: 25.26px;
                    }

                    img:first-child {
                        position: absolute;
                        left: 255px;
                        top: 28px;
                    }

                    img:nth-child(2) {
                        position: absolute;
                        left: 157px;
                        top: 123px;
                    }

                    img:nth-child(3) {
                        position: absolute;
                        left: 236px;
                        top: 190px;
                    }

                    img:nth-child(4) {
                        position: absolute;
                        left: 151px;
                        top: 278px;
                    }

                    .tips1,
                    .tips2,
                    .tips3,
                    .tips4 {
                        .tipsTitle {
                            font-size: 18px;
                        }

                        .tipsContent {
                            .tipsConTitle {
                                font-size: 16px;
                                line-height: 16px;
                            }

                            .tipsConCon {
                                font-weight: 400;
                                font-size: 14px;
                            }
                        }
                    }

                    .tips1 {
                        width: 352px !important;
                        position: absolute;
                        top: 54px !important;
                        left: -132px !important;
                    }

                    .tips2 {
                        width: 266px !important;
                        position: absolute;
                        top: 25px;
                        left: -171px;
                    }

                    .tips3 {
                        position: absolute;
                        top: 50px;
                        left: -178px;
                        width: 350px !important;
                    }

                    .tips4 {
                        position: absolute;
                        top: 39px;
                        left: -118px;
                        width: 303px !important;
                    }
                }
            }
        }
    }
}

@media only screen and (min-width: 576px) and (max-width: 1023px) {
    .strategyLayout1 {
        height: 1100px;

        .titleStrate {
            text-align: center;
        }

        .conStrate {
            display: flex;
            align-items: center;
            flex-direction: column;

            .conSLeft {
                width: 688px;

                .conSLeftB {
                    margin: 50px auto;
                    width: 456px;
                    align-items: center;
                }

                .conSLeftB>div:nth-child(1) {
                    position: relative;
                    left: 75px;
                }

                .conSLeftB>div:nth-child(2) {
                    width: calc(100% - 160px);
                    position: relative;
                    left: 100px;

                }
            }
        }

        .conSRight {
            width: 688px;

            .mapClass {
                background-image: url('@/assets/img/map/x3/320/map_pad&phone.png') !important;
                background-repeat: no-repeat !important;
                background-size: 320px 432px !important;
                position: relative !important;
                top: 20px !important;

                img {
                    width: 25.26px !important;
                    height: 25.26px !important;
                }

                img:first-child {
                    position: absolute;
                    left: 255px !important;
                    top: 28px !important;
                }

                img:nth-child(2) {
                    position: absolute;
                    left: 157px !important;
                    top: 123px !important;
                }

                img:nth-child(3) {
                    position: absolute;
                    left: 236px !important;
                    top: 190px !important;
                }

                img:nth-child(4) {
                    position: absolute;
                    left: 152px !important;
                    top: 275px !important;
                }

                .tips1,
                .tips2,
                .tips3,
                .tips4 {
                    .tipsTitle {
                        font-size: 18px;
                    }

                    .tipsContent {
                        .tipsConTitle {
                            font-size: 16px;
                            line-height: 16px;
                        }

                        .tipsConCon {
                            font-weight: 400;
                            font-size: 14px;
                        }
                    }
                }

                .tips1 {
                    width: 352px !important;
                    position: absolute;
                    top: 50px !important;
                    left: -157px !important;
                }

                .tips2 {
                    width: 266px !important;
                    position: absolute;
                    top: 0px !important;
                    left: -174px !important;
                }

                .tips3 {
                    position: absolute;
                    top: 66px !important;
                    left: -174px !important;
                    width: 350px !important;
                }

                .tips4 {
                    position: absolute;
                    top: 10px !important;
                    left: 30px !important;
                    width: 214px !important;
                }
            }
        }
    }

}

@media only screen and (max-width: 576px) {
    .strategyLayout1 {
        height: 100%;
        margin: 0 auto;
        height: 1860px;

        .titleStrate {
            text-align: center;

            p:first-child {
                height: 68px;
                font-size: 24px;
                font-weight: 500;
                line-height: 33.6px;
                width: 240px !important;
                margin: 0 auto;
            }

            p:nth-child(2) {
                font-size: 16px;
                height: 16px;
                line-height: 16px;
                margin: 16px auto 0 auto;
            }
        }

        .conStrate {
            display: flex;
            align-items: center;
            flex-direction: column;

            .conSLeft {
                width: 335px;

                .conSLeftB {
                    margin: 25px auto;
                    justify-content: space-evenly;

                    .fade-in {
                        margin: 25px 8px;
                        /* 适当增加左右间距，防止横排挤压 */
                        width: auto;
                        min-width: 120px;

                        .fade-in-title {
                            width: auto !important;
                            display: flex;
                            justify-content: center;
                            align-items: baseline; // 让数字和单位底部对齐更自然
                            color: #0052a4;

                            .fade-in-count {
                                font-size: 60px;
                                line-height: 1; // 保持比例
                                font-style: italic;
                                padding: 0 8px 0 4px; // 右侧多留点空间给斜体倾斜
                                overflow: visible; // 关键：允许斜体边缘溢出显示
                                -webkit-tap-highlight-color: transparent;
                                will-change: transform; // 优化动画
                            }

                            .fade-in-units {
                                font-size: 16px;
                                margin-left: 2px; // 手动控制单位和数字的距离
                                white-space: nowrap;
                                /* 强制不换行 */
                                flex-shrink: 0;
                                /* 防止在 Flex 布局中被压缩宽度 */
                            }
                        }

                        .fade-content {
                            margin-top: 12px;
                            text-align: center;
                        }
                    }

                    // 删掉那个通用的 div { margin: ... }
                }
            }

            .conSRight {
                width: 335px;

                .mapClass {
                    background-image: url('@/assets/img/map/x3/320/map_pad&phone.png');
                    background-repeat: no-repeat;
                    background-size: 320px 432px;
                    width: 120%;
                    position: absolute;
                    top: 60%;
                    left: 63%;
                    transform: translate(-50%, -50%);

                    img {
                        width: 25.26px;
                        height: 25.26px;
                    }

                    img:first-child {
                        position: absolute;
                        left: 254px;
                        top: 28px;
                    }

                    img:nth-child(2) {
                        position: absolute;
                        left: 155px;
                        top: 121px;
                    }

                    img:nth-child(3) {
                        position: absolute;
                        left: 233px;
                        top: 190px;
                    }

                    img:nth-child(4) {
                        position: absolute;
                        left: 152px;
                        top: 274px;
                    }

                    .tips1,
                    .tips2,
                    .tips3,
                    .tips4 {
                        width: 279px !important;
                        position: absolute;
                        top: 460px;
                        left: -10px;
                        ;

                        .tipsTitle {
                            font-size: 18px;
                            line-height: 18px;
                            padding-bottom: 10px;
                            border-bottom: 2px solid #ffffff;
                        }

                        .tipsContent {
                            .tipsConCon {
                                font-size: 14px;
                                line-height: 14px;
                                width: 282px;
                            }
                        }
                    }
                }
            }
        }

    }
}
</style>
